import { View } from '@play-co/timestep-core/ui';
import {
  LangBitmapFontTextShadowView,
  LangBitmapFontTextShadowViewOpts,
} from 'src/lib/ui/components/LangBitmapFontTextShadowView';
import i18n from 'src/lib/i18n/i18n';
import sounds from 'src/lib/sounds';
import ButtonScaleView from 'src/lib/ui/components/ButtonScaleView';
import gsap from 'gsap';

type StreakTapToContinueOptions = {
  superview: View;
  offsetY?: number;
  textOpts?: LangBitmapFontTextShadowViewOpts;
  tracking: { feature: string; $subFeature: string };
  onClick: () => void;
};

export default class StreakTapToContinue {
  constructor(opts: StreakTapToContinueOptions) {
    const prompt = new LangBitmapFontTextShadowView({
      superview: opts.superview,
      font: 'Body',
      localeText: () => i18n('match2.streakBattleRoyale.matchmaking.prompt'),
      size: 35,
      align: 'center',
      verticalAlign: 'center',
      color: '#FFFFFF',
      width: opts.superview.style.width,
      height: 54,
      y: opts.superview.style.height - 130 + (opts.offsetY ?? 0),
      textShadowOffsetX: 0,
      textShadowOffsetY: 5,
      textShadowOpacity: 0.5,
      ...opts.textOpts,
      opacity: 0,
      canHandleEvents: false,
    });

    gsap.to(prompt.style, {
      duration: 0.75,
      opacity: 1,
      ease: 'quad.out',
      repeat: -1,
      yoyo: true,
      overwrite: true,
    });

    // full-screen button
    const button = new ButtonScaleView({
      superview: opts.superview,
      infinite: true,
      onClick: async () => {
        // Disable to prevent subsequent clicks
        button.style.visible = false;
        sounds.sfx.play('ok');
        opts.onClick();
        await gsap.to(prompt.style, {
          duration: 0.3,
          opacity: 0,
          ease: 'quad.inOut',
          overwrite: true,
        });
        prompt.removeFromSuperview();
        button.removeFromSuperview();
      },
      tracking: opts.tracking,
    });
  }
}
